module.exports = __webpack_public_path__ + "img/maestro.3d0d046f.svg";